import application from 'application/application';

import template from './users.template.html';

import controller from './users.controller';

application

	.config(['$stateProvider', $stateProvider => {

		$stateProvider

			.state('root.default.account.users', {
				url: '/planos',
				views: {
					'default@root.default': {
						templateUrl: template,
						controller
					}
				},
				data: {
					documentTitle: 'Usuários'
				}
			});

	}]);
